import { createAction, props } from '@ngrx/store';
import { ILoggerDeployment } from '@app/api/interfaces/logger-deployment-data.interface';
import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { ILoggerDeploymentsRequestState } from '@app/main/main-screen/store/data/logger-deployments/logger-deployments.state';

export const loadLoggerDeployments = createAction(
  '[LoggerDeployments] Load Logger Deployments',
  props<{ triggerId: string; request: ILoggerDeploymentsRequestState }>()
);

export const loadLoggerDeploymentsSuccess = createAction(
  '[LoggerDeployments] Load Logger Deployments Success',
  props<{ triggerId: string; request: ILoggerDeploymentsRequestState; loggerDeployments: ILoggerDeployment[] }>()
);

export const loggerDeploymentsFailure = createAction(
  '[LoggerDeployments] Load Failure',
  props<{ error: IApiBaseErrorResponse }>()
);

export const getLoggerDeployment = createAction(
  '[LoggerDeployments] Get LoggerDeployment',
  props<{ loggerDeploymentId: string }>()
);

export const getLoggerDeploymentSuccess = createAction(
  '[LoggerDeployments] Get LoggerDeployment Success',
  props<{ loggerDeployment: ILoggerDeployment }>()
);

export const getLoggerDeploymentFailure = createAction(
  '[LoggerDeployments] Get LoggerDeployment Failure',
  props<{ loggerDeploymentId: string; error: IApiBaseErrorResponse }>()
);
